import { Injectable } from '@angular/core';

export interface QohPopoverDocumentHandlers {
	onDocumentKeydown(ev: KeyboardEvent): void;
	onDocumentClick(ev: MouseEvent): void;
}

@Injectable({ providedIn: 'root' })
export class QohPopoverDocumentService {
	private active: QohPopoverDocumentHandlers | null = null;
	private attached = false;

	private readonly boundKeydown = (ev: KeyboardEvent) => {
		this.active?.onDocumentKeydown(ev);
	};

	private readonly boundClick = (ev: MouseEvent) => {
		this.active?.onDocumentClick(ev);
	};

	attach(handlers: QohPopoverDocumentHandlers): void {
		this.active = handlers;
		if (!this.attached) {
			document.addEventListener('keydown', this.boundKeydown);
			document.addEventListener('click', this.boundClick);
			this.attached = true;
		}
	}

	detach(handlers: QohPopoverDocumentHandlers): void {
		if (this.active !== handlers) {
			return;
		}
		this.active = null;
		if (this.attached) {
			document.removeEventListener('keydown', this.boundKeydown);
			document.removeEventListener('click', this.boundClick);
			this.attached = false;
		}
	}
}
